import { DataTypeSearchCombo, ensureDataTypeSearchComboArray } from 'modules/domains';
import { ElementType, useElementIndex } from 'modules/queryBuilder/legacyQueryBuilder/contexts';
import { replaceElementAt } from 'utils/arrayHelpers';

import { useCriteriaState } from '../useCriteriaState';

export type SetRequirementFn = (requirement: DataTypeSearchCombo) => void;

export const useSetRequirement = (): SetRequirementFn => {
  const [criteria, setCriteria] = useCriteriaState();
  const indexToUpdate = useElementIndex(ElementType.Requirement);
  const existingRequirementsArray = ensureDataTypeSearchComboArray(criteria.searchQueries);
  return function setRequirement(updatedRequirement: DataTypeSearchCombo) {
    setCriteria({
      ...criteria,
      searchQueries: replaceElementAt(existingRequirementsArray, indexToUpdate, updatedRequirement),
    });
  };
};
